// src/components/dashboard/SupportOutlet.jsx
//
// Self-contained "Talk to Someone" entry: resolves the org's support contact for
// THIS member's type, renders a button, and pops the SupportContactModal. Renders
// nothing when the org has no reachable contact for them, so any surface can drop
// it into a hero without extra plumbing. (The athlete DashboardView keeps its own
// inline version because its safety card opens the same modal from a second spot.)

import React, { useState } from 'react';
import { HeartHandshake } from 'lucide-react';
import { useOrganization } from '../../context/OrganizationContext';
import { resolveSupportContact, hasReachableContact, resolveEapProgram } from '../../utils/resolveSupportContact';
import SupportContactModal from './SupportContactModal';
import { resolveAgeTier } from '../../utils/ageTier';
import { recordContentEvent } from '../../utils/contentEvents';

const SupportOutlet = ({ currentUser, label = 'Talk to Someone', className, topicId = null }) => {
    const { orgData, isPreviewMode } = useOrganization();
    const [open, setOpen] = useState(false);
    const openOutlet = () => {
        setOpen(true);
        recordContentEvent('support_open', { user: currentUser, org: orgData, isPreviewMode, topicId, resourceId: eap ? 'eap' : (contact ? 'contact' : 'lines'), resourceType: 'Support' });
    };

    // Personal contact and/or the org's EAP program — either justifies the outlet.
    const contact = resolveSupportContact(orgData, currentUser?.memberType);
    const eap = resolveEapProgram(orgData, currentUser?.memberType);
    // No early return: the modal carries Canada-correct lines as a floor, so the
    // outlet exists for every member even before an org configures anything.
    void hasReachableContact;

    return (
        <>
            <button
                type="button"
                onClick={openOutlet}
                className={className || 'px-6 py-3 bg-white/10 hover:bg-white/20 text-white border border-white/30 rounded-full font-bold transition-all flex items-center gap-2'}
            >
                <HeartHandshake size={18} /> {label}
            </button>
            {open && <SupportContactModal contact={contact} eap={eap} onClose={() => setOpen(false)} topicId={topicId} memberType={currentUser?.memberType} ageTier={resolveAgeTier(currentUser)} />}
        </>
    );
};

export default SupportOutlet;
